
  import React from "react"
  import Component from "/Users/kodemi/Projects/rubae/src/layouts/index.js"
  import data from "/Users/kodemi/Projects/rubae/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js